import { createNode, PlainTimeDataType } from '@glueapp/graph-types';
import { toPlainTime, fromPlainTime } from '../../utils/temporal';

export const SetTimeComponents = createNode({
    id: 'Set Time Components',
    name: 'Set Time Components',
    description: 'Creates a new Time with one or more components replaced',
    aiDescription:
        'Takes a Time on the "Time" port and optional number overrides on "Hour", "Minute", "Second", and "Millisecond" ports, and outputs a new Time on the "Time" port with the specified components replaced.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Time: PlainTimeDataType,
        Hour: { kind: 'number' },
        Minute: { kind: 'number' },
        Second: { kind: 'number' },
        Millisecond: { kind: 'number' },
    },
    optionalInPorts: ['Hour', 'Minute', 'Second', 'Millisecond'],
    outPorts: {
        Time: PlainTimeDataType,
    },
    execute: function (input) {
        const time = toPlainTime(input.inPorts.Time);
        const overrides: Record<string, number> = {};
        if (input.inPorts.Hour != null) overrides.hour = input.inPorts.Hour;
        if (input.inPorts.Minute != null) overrides.minute = input.inPorts.Minute;
        if (input.inPorts.Second != null) overrides.second = input.inPorts.Second;
        if (input.inPorts.Millisecond != null) overrides.millisecond = input.inPorts.Millisecond;
        const result = time.with(overrides);
        return { output: { Time: fromPlainTime(result) } };
    },
});
